import { getGlobalLogger } from '@zg-rentals/logger-browser';

export async function getUrlFromPdfResponse(pdfResponse: Response) {
  try {
    const blob = await pdfResponse.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    getGlobalLogger('getUrlFromPdfResponse').error(`failed to create URL from PDF response. ${err}`);
    throw err;
  }
}

export function getUrlFromBase64PdfString(base64String: string) {
  try {
    const binaryArray = Uint8Array.from(atob(base64String), (char) => char.charCodeAt(0));
    const blob = new Blob([binaryArray], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  } catch (err) {
    getGlobalLogger('getUrlFromBase64PdfString').error(`failed to create URL from base64 PDF string. ${err}`);
    throw err;
  }
}

function validateUrl(urlString: string) {
  const { protocol } = new URL(urlString);
  if (protocol !== 'blob:' && protocol !== 'http:' && protocol !== 'https:') {
    throw new Error(`invalid URL: ${urlString}`);
  }
}

export function revokeObjectUrl(url: string) {
  URL.revokeObjectURL(url);
}

export function openPdfUrlInNewTab(url: string, cleanupUrlFromMemory = true) {
  try {
    validateUrl(url);
    const newWindow = window.open(url, '_blank');

    if (cleanupUrlFromMemory) {
      revokeObjectUrl(url);
    }

    return newWindow;
  } catch (err) {
    getGlobalLogger('openPdfUrlInNewTab').error(`failed to open PDF url in new tab. ${err}`);
    throw err;
  }
}

export function downloadPdfUrl(url: string, filename: string, cleanupUrlFromMemory = true) {
  try {
    validateUrl(url);
    if (!filename) {
      const errorMessage = `invalid filename: ${filename}`;
      getGlobalLogger('downloadPdfUrl').error(errorMessage);
      throw new Error(errorMessage);
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (cleanupUrlFromMemory) {
      revokeObjectUrl(url);
    }
  } catch (err) {
    getGlobalLogger('downloadPdfUrl').error(`failed to download pdf url. ${err}`);
    throw err;
  }
}
